<template>
  <div class="news-com">
    <div class="news-container">
      <div class="row">
        <ul class="news-list">
          <transition name="fade" v-for="(item, index) in list" :key="index" v-if="list.length > 0">
            <li class="news-item" v-show="item.show">
              <div
                style="display: inline-flex;cursor: pointer"
                @click="$router.push({ name: 'announcement-detail', query: { id: item.id } })"
              >
                <div class="notice-text">{{ item.title }}</div>
                <b><img :src="require('@/assets/images/home/new.png')" alt=""/></b>
              </div>
            </li>
          </transition>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { messagesApi } from '../../api/user/messagesApi';
export default {
  name: 'Banner',
  components: {},
  data() {
    return {
      list: [],
      timer: undefined,
      active: 0,
      isStart: false
    };
  },
  props: {
    // 每隔多久新闻切换一次
    time: {
      type: Number,
      default: 5000
    }
  },
  methods: {
    start() {
      if (this.list.length == 0 || this.isStart) {
        return;
      }
      this.isStart = true;
      let list = this.list;

      list.forEach(item => {
        if (typeof item.show === 'undefined') {
          this.$set(item, 'show', false);
        }
      });

      this.stop();

      list[this.active].show = true;
      this.timer = setInterval(() => {
        // 先将已经显示的隐藏掉
        list[this.active].show = false;
        if (this.active + 1 == list.length) {
          this.active = 0;
        } else {
          this.active++;
        }
        list[this.active].show = true;
      }, this.time);
    },
    stop() {
      clearInterval(this.timer);
    }
  },
  watch: {
    list() {
      if (this.list.length === 0) {
        return;
      }
      this.start();
    }
  },
  mounted() {
    messagesApi
      .getNotifications()
      .then(res => {
        this.list = res.data.notices;
      })
      .catch(() => {
        // unreadMsgData.loading = false;
      });
  }
};
</script>

<style lang="stylus" scoped>
.notice-out-wrap {
  position: relative;
  z-index: 10;
}
.notice-wrap {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: rgba(26, 31, 51, 0.8);
}
.notice-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  line-height: 46px;
  color: #fff;
}
.notice-wrap ul {
  flex: 1 1 0px;
  display: flex;
  align-items: center;
}
.notice-wrap ul li {
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  color: rgba(179, 195, 221, 1);
  padding-right: 30px;
  margin: 0 auto;
}
.notice-wrap ul li span {
  overflow: hidden;
  text-overflow: ellipsis;
}
.notice-wrap ul li b {
  margin: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.notice-inner div {
  font-size: 12px;
  color: rgba(179, 195, 221, 1);
  cursor: pointer;
  user-select: none;
}

.notice-item {
  opacity: 0.9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.fade-enter-active {
    opacity: 1;
    transition: opacity 0.5s;
  }

  &.fade-enter,
  &.fade-leave {
    opacity: 0;
  }

  a {
    font-size: 1.2em;
    color: #fff;
  }
}

.notice-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 392px;
  margin-right: 5px;
}

.news-com {
  height: 42px;
  line-height: 42px;
  overflow: hidden;
  background-color: rgba(26, 31, 51, 0.8);
}

.news-container{
    width: 100%;
    padding: 0px;
    margin: 0 auto;
}

.news-list {
  width: 100%;
}
.news-item {
  color: #fff;
  opacity: 0.9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 320px) {
  .notice-text {
    max-width: 250px;
    font-size: 14px;
  }
}
</style>
